import { faWindowClose } from "@fortawesome/pro-regular-svg-icons/faWindowClose";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ModalContext from "../../context";
import { MODAL_CLASS } from "../modal.constants";
import { IProps } from "./close-button.types";
import { useContext } from "react";

/**
 * Render a modal close button.
 * @returns A button element that will close a modal.
 */
const CloseButton = ({ label }: IProps) => {
    const { hideModal } = useContext(ModalContext);

    return (
        <button className={`${MODAL_CLASS}__close`} onClick={hideModal} aria-label={label} type="button">
            <FontAwesomeIcon title="Close modal" icon={faWindowClose} />
        </button>
    );
};

export default CloseButton;
